const getters = {
    hasErrorInService: state => state.hasErrorInService,
    getPx: state => state.px,
    id_person: state => state.id_person
}

export default getters